import { animate, query, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, OnDestroy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { interval, map, take, tap } from 'rxjs';
import { CreateDocumentOnNewStructureService } from 'src/app/core/services/create-document-on-new-structure.service';
import { DownloadService, enumDownloadState } from 'src/app/core/services/download.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
    selector: 'app-new-tab-helper',
    imports: [CommonModule, SharedModule],
    templateUrl: './new-tab-helper.component.html',
    styleUrls: ['./new-tab-helper.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition('* => *', [
                query(':enter', [
                    style({ opacity: 0, scale: 0.9 }),
                ], { optional: true }),
                query(':leave', [
                    animate('0.3s', style({ opacity: 0, scale: 0.9 }))
                ], { optional: true }),
                query(':enter', [
                    animate('0.3s', style({ opacity: 1, scale: 1 }))
                ], { optional: true })
            ])
        ]),
        trigger('rollInOut', [
            transition(':enter', [
                style({ transform: 'translateY(50px)', opacity: 0 }),
                animate('250ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                animate('100ms ease-in', style({ transform: 'translateY(-50px)', opacity: 0 }))
            ])
        ])
    ]
})
export class NewTabHelperComponent implements OnDestroy {
  createDocumentService = inject(CreateDocumentOnNewStructureService)
  route = inject(ActivatedRoute)
  downloadService = inject(DownloadService)
  params = this.route.snapshot.queryParams;

  url$ = this.createDocumentService.downloadDynamicDocument(
    this.params.contractDocumentCode,
    this.params.type,
    this.params.language).pipe(tap(() => {
      document.body.style.overflow = 'hidden';
    }));


  url = toSignal(this.url$)
  isInProgreess = computed(() => this.url().state !== enumDownloadState.DONE)
  isInPending = computed(() => this.url().state === enumDownloadState.PENDING)
  progressPercentage = computed(() => this.url().progress)

  constructor() {
    effect(() => {

      if (this.url()?.url && this.isSafariOrFirefox()) {
        debugger
        this.downloadService.savePdf(this.url().url).subscribe()
      }

    })
  }

  private isSafariOrFirefox(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
    const isFirefox = /firefox/.test(userAgent);
    return isSafari || isFirefox;
  }


  ngOnDestroy(): void {
    document.body.style.overflow = 'auto';
  }
}
